import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

const NewRecordingCursor = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 60) / fps;
	return (
		<MacOSCursor
			cursor={interpolate(
				frame,
				[2, 69, 277, 307, 308],
				['auto', 'default', 'auto', 'col-resize', 'auto'],
				{
					easing: Easing.step1,
					extrapolateLeft: 'clamp',
					extrapolateRight: 'clamp',
				},
			)}
			style={{
				position: 'absolute',
				left: 0,
				top: 0,
				scale: interpolate(
					frame,
					[0, 29, 35, 358, 365],
					[
						6.943942133815551, 6.249547920433996, 6.943942133815551,
						6.249547920433996, 6.943942133815551,
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				),
				translate: interpolate(
					frame,
					[
						2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
						21, 22, 23, 24, 25, 28, 29, 34, 35, 40, 41, 42, 43, 44, 45, 46, 47,
						48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64,
						65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81,
						82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
						99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
						113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125,
						126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138,
						139, 140, 141, 142, 158, 159, 160, 161, 162, 163, 164, 165, 166,
						167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179,
						180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192,
						193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205,
						206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218,
						219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231,
						232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244,
						245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257,
						258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270,
						271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283,
						284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296,
						297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309,
						310, 311, 312, 313, 314, 315, 334, 335, 336, 337, 338, 339, 340,
						341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353,
						354, 357, 358, 364, 365,
					],
					[
						'-3491.9349005424956px 5931.781193490054px',
						'-3005.5605786618444px 5638.589511754069px',
						'-2143.8336347197105px 5071.491862567812px',
						'-1307.4683544303798px 4485.813743218807px',
						'-460.79566003616634px 3741.23869801085px',
						'94.8010849909584px 3061.1121157323687px',
						'237.07052441229655px 2860.1175406871607px',
						'237.07052441229655px 2860.1175406871607px',
						'250.7142857142857px 2854.502712477396px',
						'276.0759493670886px 2844.0867992766725px',
						'282.36889692585896px 2841.482820976492px',
						'286.6003616636528px 2840.397830018083px',
						'300.8951175406872px 2838.0650994575044px',
						'334.3128390596745px 2834.783001808318px',
						'384.873417721519px 2834.891500904159px',
						'413.38155515370704px 2836.0578661844484px',
						'421.1392405063291px 2836.491862567812px',
						'421.22061482820976px 2836.491862567812px',
						'421.3291139240506px 2836.491862567812px',
						'421.3291139240506px 2836.491862567812px',
						'437.3869801084991px 2827.2965641952983px',
						'588.5262206148282px 2691.482820976492px',
						'800.7233273056057px 2425.4430379746836px',
						'926.7992766726944px 2225.533453887884px',
						'926.7992766726944px 2225.533453887884px',
						'926.7992766726944px 2225.533453887884px',
						'926.7992766726944px 2225.533453887884px',
						'926.7992766726944px 2225.533453887884px',
						'926.7992766726944px 2225.533453887884px',
						'922.2965641952984px 2221.9258589511755px',
						'891.9710669077757px 2166.23869801085px',
						'858.8517179023507px 2086.980108499096px',
						'805.0904159132007px 1969.7739602169981px',
						'776.2025316455696px 1909.9095840867992px',
						'763.4267631103074px 1873.2911392405063px',
						'763.4267631103074px 1873.2911392405063px',
						'749.5660036166365px 1818.8245931283905px',
						'747.8842676311031px 1810.0904159132008px',
						'740.2079566003616px 1748.4358047016274px',
						'735.867992766727px 1715.0452079566003px',
						'730.0361663652802px 1688.517179023508px',
						'725.8589511754069px 1667.7938517179023px',
						'717.4502712477396px 1645.7142857142858px',
						'707.0614828209765px 1623.1735985533453px',
						'701.7992766726944px 1606.3562386980109px',
						'700.5786618444846px 1593.1735985533453px',
						'700.5786618444846px 1571.745027124774px',
						'699.5207956600361px 1547.0343580470162px',
						'698.5443037974684px 1531.4104882459312px',
						'698.625678119349px 1508.8155515370704px',
						'699.5750452079566px 1493.625678119349px',
						'700.741410488246px 1473.8517179023509px',
						'701.3381555153707px 1460.2079566003617px',
						'701.9349005424955px 1446.6455696202531px',
						'702.3960216998191px 1428.390596745027px',
						'701.7992766726944px 1415.1537070524412px',
						'695.1537070524412px 1395.6509945750452px',
						'684.9547920433996px 1373.5714285714284px',
						'673.4267631103074px 1347.9656419529838px',
						'672.6672694394214px 1333.9692585895118px',
						'672.6672694394214px 1325.994575045208px',
						'672.6672694394214px 1312.7848101265822px',
						'672.6672694394214px 1303.4538878842675px',
						'672.6672694394214px 1289.132007233273px',
						'672.6672694394214px 1279.2857142857142px',
						'673.4810126582279px 1269.0596745027124px',
						'674.1862567811935px 1262.3327305605787px',
						'674.1862567811935px 1255.877034358047px',
						'674.1862567811935px 1245.4339963833634px',
						'674.1862567811935px 1242.640144665461px',
						'673.4267631103074px 1238.2730560578661px',
						'672.2332730560579px 1233.2278481012659px',
						'670.6871609403255px 1226.609403254973px',
						'670.6871609403255px 1226.609403254973px',
						'668.5985533453887px 1208.490054249548px',
						'667.3508137432187px 1191.374321880651px',
						'667.3508137432187px 1167.640144665461px',
						'668.2188065099457px 1153.3182640144664px',
						'673.4538878842676px 1127.8481012658228px',
						'677.3869801084991px 1101.5370705244122px',
						'679.5569620253165px 1066.3562386980109px',
						'680.2079566003616px 1039.5569620253164px',
						'682.5949367088607px 1010.5334538878842px',
						'684.2224231464737px 978.2820976491862px',
						'684.3851717902351px 957.4502712477396px',
						'687.0976491862567px 926.0669077757685px',
						'688.75226039783px 898.2640144665461px',
						'691.4376130198915px 860.2079566003616px',
						'692.1428571428571px 839.9186256781194px',
						'692.1428571428571px 827.6582278481012px',
						'692.1428571428571px 814.1772151898734px',
						'692.1428571428571px 804.7377938517179px',
						'692.1428571428571px 790.632911392405px',
						'692.1428571428571px 790.632911392405px',
						'687.6130198915009px 752.5768535262206px',
						'686.6365280289331px 732.124773960217px',
						'685.9041591320072px 718.1555153707052px',
						'682.8119349005425px 697.1880650994575px',
						'676.0307414104882px 672.0976491862567px',
						'660.3526220614827px 636.6726943942134px',
						'641.500904159132px 602.1428571428571px',
						'627.8842676311031px 574.8282097649186px',
						'618.6889692585895px 548.1916817359855px',
						'611.25678119349px 532.8933092224231px',
						'603.74321880651px 514.6654611211574px',
						'599.9728752260397px 503.9783001808318px',
						'596.6094032549729px 489.7920433996383px',
						'593.6528028933092px 477.88426763110306px',
						'585.4611211573236px 456.2658227848101px',
						'578.5985533453887px 435.37974683544303px',
						'576.9168173598554px 427.86618444846295px',
						'576.8354430379746px 412.48643761301986px',
						'576.6726943942134px 402.7757685352622px',
						'576.6726943942134px 402.7757685352622px',
						'575.0452079566004px 381.4014466546112px',
						'575.0452079566004px 373.4538878842676px',
						'574.4755877034357px 366.998191681736px',
						'574.0958408679927px 365.3164556962025px',
						'574.0958408679927px 364.2857142857143px',
						'574.0958408679927px 363.7703435804701px',
						'574.0958408679927px 360.8951175406871px',
						'573.878842676311px 356.28390596745027px',
						'572.4141048824594px 351.6455696202532px',
						'571.9529837251356px 347.7938517179023px',
						'571.7631103074141px 344.4575045207956px',
						'571.5461121157324px 342.6672694394213px',
						'571.5461121157324px 341.8535262206148px',
						'570.867992766727px 341.17540687160937px',
						'569.9728752260397px 339.5207956600362px',
						'569.8915009041591px 339.4122965641953px',
						'569.620253164557px 339.4122965641953px',
						'569.620253164557px 339.4122965641953px',
						'569.620253164557px 349.8282097649186px',
						'569.620253164557px 362.0614828209765px',
						'569.620253164557px 371.0126582278481px',
						'569.620253164557px 371.0126582278481px',
						'569.620253164557px 386.52802893309223px',
						'569.620253164557px 396.61844484629296px',
						'569.620253164557px 396.61844484629296px',
						'570.867992766727px 410.3978300180832px',
						'570.867992766727px 410.3978300180832px',
						'572.631103074141px 428.3273056057866px',
						'572.631103074141px 434.3490054249548px',
						'572.631103074141px 438.3905967450271px',
						'572.631103074141px 442.6491862567812px',
						'572.631103074141px 447.69439421338154px',
						'572.631103074141px 454.0415913200723px',
						'572.631103074141px 459.54792043399635px',
						'573.5804701627486px 472.3508137432188px',
						'573.74321880651px 484.44846292947557px',
						'573.7974683544304px 496.54611211573234px',
						'574.6925858951175px 510.84086799276673px',
						'574.6925858951175px 524.7830018083182px',
						'575.0180831826401px 535.7142857142857px',
						'575.5605786618445px 547.622061482821px',
						'576.130198915009px 560.5877034358047px',
						'576.4828209764919px 572.7938517179024px',
						'577.0524412296564px 581.4737793851717px',
						'578.001808318264px 592.0795660036166px',
						'578.0289330922242px 604.2857142857142px',
						'578.0289330922242px 613.0741410488246px',
						'578.0289330922242px 627.9385171790235px',
						'578.4086799276672px 641.9891500904159px',
						'579.005424954792px 655.0904159132007px',
						'579.005424954792px 655.0904159132007px',
						'579.005424954792px 674.0506329113924px',
						'579.005424954792px 684.9005424954792px',
						'579.005424954792px 691.6546112115732px',
						'579.005424954792px 699.1952983725135px',
						'579.005424954792px 703.4810126582279px',
						'579.005424954792px 709.7739602169981px',
						'579.005424954792px 717.3960216998191px',
						'579.005424954792px 723.3905967450271px',
						'579.005424954792px 729.6564195298372px',
						'579.005424954792px 734.9728752260397px',
						'579.005424954792px 740.1808318264015px',
						'579.005424954792px 744.4394213381555px',
						'579.005424954792px 748.1826401446655px',
						'579.005424954792px 752.3598553345389px',
						'578.8155515370705px 754.5298372513562px',
						'578.381555153707px 756.5641952983725px',
						'578.381555153707px 759.8462929475587px',
						'578.381555153707px 763.3182640144665px',
						'577.8119349005425px 766.9258589511754px',
						'576.9168173598554px 772.5949367088607px',
						'576.1573236889692px 777.8842676311031px',
						'573.3363471971066px 786.7269439421337px',
						'572.1971066907776px 795.5153707052441px',
						'570.2983725135624px 807.7215189873417px',
						'568.9150090415914px 818.245931283906px',
						'566.7992766726944px 831.5370705244122px',
						'564.7649186256781px 844.2857142857142px',
						'564.7649186256781px 844.2857142857142px',
						'559.5840867992766px 878.8426763110307px',
						'556.1121157323689px 897.0433996383363px',
						'556.1121157323689px 897.0433996383363px',
						'552.4773960216999px 932.9566003616636px',
						'550.8499095840867px 946.1392405063291px',
						'549.5207956600361px 957.4502712477396px',
						'546.8354430379746px 972.0162748643761px',
						'544.4213381555154px 985.0632911392405px',
						'544.4213381555154px 985.0632911392405px',
						'540.7594936708861px 1006.1121157323689px',
						'538.6437613019891px 1018.4810126582278px',
						'536.8535262206149px 1028.1916817359854px',
						'535.0904159132007px 1035.5967450271248px',
						'532.1609403254972px 1047.6672694394213px',
						'529.9638336347197px 1058.3273056057867px',
						'529.9638336347197px 1058.3273056057867px',
						'524.5660036166365px 1081.4104882459312px',
						'522.50452079566px 1094.132007233273px',
						'518.7341772151899px 1107.992766726944px',
						'515.7775768535262px 1119.385171790235px',
						'512.49547920434px 1133.245931283906px',
						'512.49547920434px 1133.245931283906px',
						'502.94755877034356px 1165.7142857142858px',
						'497.875226039783px 1179.1952983725134px',
						'497.875226039783px 1179.1952983725134px',
						'490.95840867992763px 1200.0271247739602px',
						'488.11030741410485px 1208.7884267631102px',
						'485.96745027124774px 1219.3128390596744px',
						'484.0415913200723px 1229.7830018083182px',
						'483.14647377938513px 1232.9566003616637px',
						'481.81735985533453px 1237.5949367088608px',
						'481.81735985533453px 1237.5949367088608px',
						'480.40687160940325px 1244.484629294756px',
						'479.62025316455697px 1249.1772151898733px',
						'479.62025316455697px 1249.1772151898733px',
						'478.86075949367086px 1253.7070524412297px',
						'478.61663652802895px 1259.3218806509944px',
						'478.61663652802895px 1259.3218806509944px',
						'477.88426763110306px 1263.9602169981918px',
						'477.53164556962025px 1269.9547920433997px',
						'475.5786618444846px 1278.6889692585894px',
						'473.5985533453888px 1288.9692585895118px',
						'473.5985533453888px 1288.9692585895118px',
						'470.96745027124774px 1301.6907775768534px',
						'470.3164556962025px 1305.379746835443px',
						'470.126582278481px 1309.0958408679928px',
						'469.3399638336347px 1314.7920433996383px',
						'468.3634719710669px 1323.2820976491862px',
						'467.875226039783px 1328.6799276672693px',
						'467.6853526220615px 1337.9023508137432px',
						'466.9801084990958px 1343.381555153707px',
						'466.9801084990958px 1343.381555153707px',
						'466.1392405063291px 1357.51356238698px',
						'465.8951175406871px 1365.135623869801px',
						'465.8951175406871px 1372.9475587703434px',
						'465.24412296564196px 1378.860759493671px',
						'465.24412296564196px 1378.860759493671px',
						'465.0813743218806px 1389.873417721519px',
						'464.5388788426763px 1394.7830018083182px',
						'464.5388788426763px 1400.126582278481px',
						'464.5388788426763px 1405.0632911392404px',
						'464.0777576853526px 1408.3182640144664px',
						'463.83363471971063px 1413.6618444846292px',
						'462.9385171790235px 1423.7251356238698px',
						'462.9385171790235px 1423.7251356238698px',
						'462.124773960217px 1435.4430379746834px',
						'462.124773960217px 1435.4430379746834px',
						'461.52802893309223px 1445.5334538878842px',
						'461.52802893309223px 1450.4159132007233px',
						'461.52802893309223px 1450.4159132007233px',
						'461.52802893309223px 1455.3526220614829px',
						'461.90777576853526px 1468.264014466546px',
						'462.0162748643761px 1471.491862567812px',
						'462.0162748643761px 1474.1772151898733px',
						'462.0162748643761px 1475.2893309222422px',
						'462.0162748643761px 1479.98191681736px',
						'462.0162748643761px 1483.7251356238698px',
						'461.6907775768535px 1487.5226039783001px',
						'460.17179023508135px 1490.9132007233272px',
						'456.97106690777576px 1496.0940325497288px',
						'449.8101265822785px 1506.6726943942133px',
						'449.8101265822785px 1506.6726943942133px',
						'436.4104882459313px 1517.875226039783px',
						'314.8915009041591px 1616.5551537070523px',
						'314.8915009041591px 1616.5551537070523px',
						'110.56057866184449px 1895.01808318264px',
						'110.56057866184449px 1895.01808318264px',
						'-32.631103074141045px 2173.6166365280287px',
						'-281.79927667269436px 2623.8336347197105px',
						'-642.9656419529837px 3127.2965641952983px',
						'-1457.115732368897px 4129.611211573237px',
						'-1979.240506329114px 4765.849909584087px',
						'-2579.8372513562385px 5564.457504520796px',
						'-2807.0614828209764px 5895.949367088608px',
						'-2965.3616636528027px 6136.546112115732px',
						'-3065.913200723327px 6283.9150090415915px',
						'-3065.913200723327px 6283.9150090415915px',
						'-3663.010849909584px 6313.77938517179px',
						'-3657.0433996383363px 6285.705244122965px',
						'-3653.218806509946px 6268.453887884268px',
						'-3649.394213381555px 6246.672694394213px',
						'-3647.414104882459px 6231.130198915009px',
						'-3646.22061482821px 6215.452079566004px',
						'-3644.023508137432px 6201.699819168173px',
						'-3640.5515370705243px 6187.4321880651px',
						'-3635.641952983725px 6170.614828209765px',
						'-3631.003616636528px 6155.614828209765px',
						'-3628.0741410488245px 6145.06329113924px',
						'-3627.3417721518986px 6142.54068716094px',
						'-3626.907775768535px 6141.184448462929px',
						'-3626.907775768535px 6141.184448462929px',
						'-3620.5877034358045px 6135.02712477396px',
						'-3615.2983725135623px 6131.28390596745px',
						'-3613.72513562387px 6130.5786618444845px',
						'-3610.8227848101264px 6129.846292947559px',
						'-3608.517179023508px 6129.4122965641955px',
						'-3608.381555153707px 6129.4122965641955px',
						'-3608.381555153707px 6129.4122965641955px',
						'-3608.381555153707px 6129.4122965641955px',
						'-3608.381555153707px 6129.4122965641955px',
						'-3608.381555153707px 6129.4122965641955px',
					],
					{
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				),
			}}
		/>
	);
};

export const ExploreNewRecording20261028Composition = () => {
	const {fps} = useVideoConfig();
	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(420 / 60) * fps}
			style={{width: 2418, height: 1440}}
		>
			<Video
				src="https://remotion.media/explore-remotion/new-source-2026-10-28-b2cc74a3b591.mp4"
				muted
				durationInFrames={(420 / 60) * fps}
				style={{position: 'absolute'}}
			/>
			<NewRecordingCursor />
		</AbsoluteFill>
	);
};
